import { useEffect } from 'react';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-20">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">プライバシーポリシー</h1>
          <p className="text-lg text-teal-50">最終更新日: 2023年10月12日</p>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          {/* About Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-teal-500">
              私たちについて
            </h2>
            <p className="text-gray-700 leading-relaxed">
              私たちのサイトアドレスは http://mm.ai-adult.org です。
            </p>
          </section>

          {/* Introduction */}
          <section className="mb-12">
            <p className="text-gray-700 leading-relaxed mb-6">
              個人のブログのプライバシーポリシーは、一般的には以下のような内容を含むことがあります。ただし、ブログの内容や収集する情報によって異なる部分があるかもしれませんので、必要に応じてカスタマイズしてください。
            </p>
            <div className="border-t-2 border-gray-200 my-8"></div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              [アカシックレコード] プライバシーポリシー
            </h3>
            <p className="text-gray-600 mb-8">
              <strong>有効日: [2023/10/12]</strong>
            </p>
          </section>

          {/* Section 1 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">1</span>
              収集する情報
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              [<strong>アカシックレコード</strong>](以下「当ブログ」と称します)は、以下の情報を収集することがあります。
            </p>
            <div className="ml-11 space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">1.1 コメント</p>
                <p className="text-gray-700 leading-relaxed">
                  当ブログの記事に対するコメントを投稿する際に、名前(ユーザー名またはニックネーム)、メールアドレス、ウェブサイト(任意)などの情報が収集されます。
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">1.2 Cookie</p>
                <p className="text-gray-700 leading-relaxed">
                  当ブログは、クッキーや類似のトラッキング技術を使用して、ウェブサイトの利用状況を収集および分析します。これにより、ウェブサイトの改善とカスタマイズが行われます。ブラウザの設定を通じてクッキーの受け入れを制限または無効にすることができます。
                </p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">2</span>
              情報の利用
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              当ブログは、収集した情報を以下の目的で利用することがあります。
            </p>
            <div className="ml-11 space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">2.1 コメントの公開</p>
                <p className="text-gray-700 leading-relaxed">
                  投稿されたコメントを当ブログの該当記事に公開することがあります。ただし、メールアドレスは公開されません。
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">2.2 コンテンツのカスタマイズ</p>
                <p className="text-gray-700 leading-relaxed">
                  収集した情報をもとに、当ブログのコンテンツをカスタマイズし、より興味深いコンテンツを提供することがあります。
                </p>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">3</span>
              第三者への情報提供
            </h3>
            <div className="ml-11">
              <p className="text-gray-700 leading-relaxed">
                当ブログは、法的要件に従うために、収集した情報を第三者と共有することがあります。
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">4</span>
              セキュリティ
            </h3>
            <div className="ml-11">
              <p className="text-gray-700 leading-relaxed">
                当ブログは、収集した情報を保護するために適切なセキュリティ対策を講じますが、完全なセキュリティを保証することはできません。
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">5</span>
              広告
            </h3>
            <div className="ml-11">
              <p className="text-gray-700 leading-relaxed">
                当ブログは、広告パートナーを通じて広告を表示することがあります。広告ネットワークはクッキーやウェブビーコンを使用して、広告のパーソナライズや効果測定を行います。
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0">6</span>
              変更とお問い合わせ先
            </h3>
            <div className="ml-11">
              <p className="text-gray-700 leading-relaxed mb-4">
                当ブログのプライバシーポリシーは変更されることがあります。最新の情報については、本ページを定期的に確認してください。
              </p>
              <p className="text-gray-700 leading-relaxed">
                プライバシーポリシーに関する質問や懸念がある場合、お気軽に[お問い合わせ先]までご連絡ください。
              </p>
            </div>
          </section>

          <div className="border-t-2 border-gray-200 my-8"></div>

          {/* Footer Note */}
          <section className="bg-teal-50 p-6 rounded-lg">
            <p className="text-gray-700 leading-relaxed text-sm">
              このテンプレートは、個人のブログ向けの基本的なプライバシーポリシーの枠組みです。ブログの内容や収集する情報に応じて、適切にカスタマイズしてください。また、法的要件や地域に関する規制にも準拠するよう注意してください。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
